var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;

  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];

  return r;
};

import StandardVirtualAudioNode from './VirtualAudioNodes/StandardVirtualAudioNode';

var createNodeConstructor = function (nodeName) {
  return function (output) {
    var rest = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      rest[_i - 1] = arguments[_i];
    }

    if (nodeName === 'mediaStreamDestination') {
      return new StandardVirtualAudioNode(nodeName);
    }

    if (output == null) {
      throw new Error("Output not specified for " + nodeName);
    }

    return new (StandardVirtualAudioNode.bind.apply(StandardVirtualAudioNode, __spreadArrays([void 0, nodeName, output], rest)))();
  };
};

export var analyser = createNodeConstructor('analyser');
export var biquadFilter = createNodeConstructor('biquadFilter');
export var bufferSource = createNodeConstructor('bufferSource');
export var channelMerger = createNodeConstructor('channelMerger');
export var channelSplitter = createNodeConstructor('channelSplitter');
export var convolver = createNodeConstructor('convolver');
export var delay = createNodeConstructor('delay');
export var dynamicsCompressor = createNodeConstructor('dynamicsCompressor');
export var gain = createNodeConstructor('gain');
export var mediaElementSource = createNodeConstructor('mediaElementSource');
export var mediaStreamDestination = createNodeConstructor('mediaStreamDestination');
export var mediaStreamSource = createNodeConstructor('mediaStreamSource');
export var oscillator = createNodeConstructor('oscillator');
export var panner = createNodeConstructor('panner');
export var stereoPanner = createNodeConstructor('stereoPanner');
export var waveShaper = createNodeConstructor('waveShaper');